import { Injectable } from '@angular/core';
import { TaskConfigurationDTO } from '../models/task.models';
import { CONFIGURE_TASKS, GET_ADMIN_CONFIGURED_TASKS, GET_ALL_TASK_CLASSIFICATIONS } from '../queries/queries';
import { Apollo } from 'apollo-angular';
import { Subject } from 'rxjs/internal/Subject';


@Injectable({
    providedIn: 'root',
})

export class CorpAdminService {
    constructor(private apolloClient: Apollo) {}

    public configuredTasks = new Subject<any>();
    configuredTasks$ = this.configuredTasks.asObservable();

    saveTask(taskData: TaskConfigurationDTO) {
        return this.apolloClient.mutate({
            mutation: CONFIGURE_TASKS,
            variables: {
                payload: JSON.stringify(taskData)
            }
        });
    }

    getAllConfiguredTasks(filter?: string) {
        return this.apolloClient.query({
            query: GET_ADMIN_CONFIGURED_TASKS,
            variables: {
                filter: filter
            },
            fetchPolicy: 'no-cache'
        }).subscribe((response: any) => {
            const tasks = response.data;
            this.configuredTasks.next(tasks);
            }
        );
    }

    getAllTaskClassifications() {
        return this.apolloClient.query({
            query: GET_ALL_TASK_CLASSIFICATIONS,
            fetchPolicy: 'no-cache'
        });
    }
}
